import React from 'react';
import { pdfFiles } from '../../body/Pdf';
import { VideoAndShowPDFAfter } from '../../body/VideoSlide';

const EightKeysToEffectiveDiscipline = () => {
  const eightKeysPdf = pdfFiles.strategiesPart2.find(
    (pdf) => pdf.name === '8 Keys to Effective Discipline',
  );

  return (
    <div className='text-left p-4 space-y-6'>
      <VideoAndShowPDFAfter
        pdfFile={eightKeysPdf}
        vidSrc={1194426171}
      />
    </div>
  );
};

export default EightKeysToEffectiveDiscipline;
